import React, { useState } from "react"

const EFFECT_DEFAULTS = {
  volume: 100,
  pitch: 0,
  warble: 0,
}

const EFFECT_CONTROLS = [
  {
    name: "volume",
    label: "Volume",
    min: 0,
    max: 150,
    step: 1,
    format: (value) => `${value}%`,
  },
  {
    name: "pitch",
    label: "Pitch",
    min: -12,
    max: 12,
    step: 1,
    format: (value) => `${value > 0 ? "+" : ""}${value} semitones`,
  },
  {
    name: "warble",
    label: "Warble",
    min: 0,
    max: 100,
    step: 1,
    format: (value) => `${value}%`,
  },
]

const AudioEffectsWindowContent = ({ initialValues = EFFECT_DEFAULTS, onChange }) => {
  const [values, setValues] = useState(() => ({ ...EFFECT_DEFAULTS, ...initialValues }))

  const updateValue = (name, value) => {
    setValues((current) => ({ ...current, [name]: value }))
    onChange?.(name, value)
  }

  const reset = () => {
    setValues(EFFECT_DEFAULTS)
    Object.entries(EFFECT_DEFAULTS).forEach(([name, value]) => onChange?.(name, value))
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 22, paddingTop: 8 }}>
      {EFFECT_CONTROLS.map((control) => (
        <label key={control.name} style={{ display: "grid", gap: 6 }}>
          <span style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
            <strong>{control.label}</strong>
            <span>{control.format(values[control.name])}</span>
          </span>
          <input
            type="range"
            min={control.min}
            max={control.max}
            step={control.step}
            value={values[control.name]}
            onChange={(event) => updateValue(control.name, Number(event.target.value))}
          />
        </label>
      ))}
      <button
        type="button"
        onClick={reset}
        style={{
          alignSelf: "flex-start",
          margin: 0,
          padding: 0,
          border: 0,
          background: "transparent",
          color: "#0d6efd",
          font: "inherit",
          textDecoration: "underline",
          cursor: "pointer",
        }}
      >
        Reset sound
      </button>
    </div>
  )
}

export { EFFECT_DEFAULTS }
export default AudioEffectsWindowContent
